import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../../../../../components/ui/Button';
import { DateRangePicker } from '../../../../../components/ui/DateRangePicker';
import { FilterableSelect } from '../../../../../components/ui/FilterableSelect';

/**
 * @param {object} props
 * @param {object} props.filters - The slice's `filters`
 * @param {(patch: object) => void} props.onFilterChange
 * @param {Array<{value: number, label: string}>} [props.companyOptions] - The
 *   admin's companies, without the "Todas" sentinel, which is prepended here.
 * @param {() => void} props.onReload
 * @param {boolean} props.isLoading
 * @param {boolean} props.isStale - Something moved since the last fetch
 */
export const DashboardFilters = ({
  filters,
  onFilterChange,
  companyOptions = [],
  onReload,
  isLoading,
  isStale,
}) => {
  const companySelectOptions = [{ value: 'all', label: 'Todas' }, ...companyOptions];

  return (
    <div className="flex flex-col md:flex-row flex-wrap items-center gap-4">
      <DateRangePicker
        startDate={filters.start_date}
        endDate={filters.end_date}
        onChange={onFilterChange}
      />

      <FilterableSelect
        label="Empresa:"
        value={filters.company}
        onChange={(value) => onFilterChange({ company: value })}
        options={companySelectOptions}
      />

      <div className="flex items-center gap-3 md:ml-auto">
        {/* Only shown when the backend said something moved and the automatic
            refetch has not caught up — a busy account is otherwise refreshing
            on its own and this would blink constantly. */}
        {isStale && !isLoading && (
          <span className="text-xs font-medium text-warning">Hay cambios sin cargar</span>
        )}

        <Button
          variant="secondary"
          size="sm"
          icon={RefreshCw}
          loading={isLoading}
          loadingLabel="Actualizando..."
          onClick={onReload}
        >
          Recargar
        </Button>
      </div>
    </div>
  );
};
